/*
Monotype Foundry Platform API
Version 1.0.0

Definition: AiDescriptionRequest

Properties:
  description: string (required), minLength: 250
  assetType: string (required)
  assetId: string
  action: string (required)
*/

var AiDescriptionRequest = (function () {
  function validateAiDescriptionRequest (arg) {
    // Validate description
    if (!arg.description) {
      throw new Error('AiDescriptionRequest.description: Missing property')
    }
    if (arg.description && !(typeof arg.description === 'string')) {
      throw new Error('AiDescriptionRequest.description: Wrong type: Got \'' + (typeof arg.description) + '\', but expected: \'string\'')
    }
    if (arg.description && !(arg.description.length >= 250)) {
      throw new Error('AiDescriptionRequest.description: Minimum length 250, but got: ' + arg.description.length)
    }
    // Validate assetType
    if (!arg.assetType) {
      throw new Error('AiDescriptionRequest.assetType: Missing property')
    }
    if (arg.assetType && !(typeof arg.assetType === 'string')) {
      throw new Error('AiDescriptionRequest.assetType: Wrong type: Got \'' + (typeof arg.assetType) + '\', but expected: \'string\'')
    }
    // Validate assetId
    if (arg.assetId && !(typeof arg.assetId === 'string')) {
      throw new Error('AiDescriptionRequest.assetId: Wrong type: Got \'' + (typeof arg.assetId) + '\', but expected: \'string\'')
    }
    // Validate action
    if (!arg.action) {
      throw new Error('AiDescriptionRequest.action: Missing property')
    }
    if (arg.action && !(typeof arg.action === 'string')) {
      throw new Error('AiDescriptionRequest.action: Wrong type: Got \'' + (typeof arg.action) + '\', but expected: \'string\'')
    }
  }
  function buildAiDescriptionRequest (arg) {
    var AiDescriptionRequest = arg
    // Complete description
    // Expected Type: string
    AiDescriptionRequest.description = AiDescriptionRequest.description || ''
    // Complete assetType
    // Expected Type: string
    AiDescriptionRequest.assetType = AiDescriptionRequest.assetType || ''
    // Complete assetId
    // Expected Type: string
    AiDescriptionRequest.assetId = AiDescriptionRequest.assetId || ''
    // Complete action
    // Expected Type: string
    AiDescriptionRequest.action = AiDescriptionRequest.action || ''
    return AiDescriptionRequest
  }
  return {
    validate: validateAiDescriptionRequest,
    build: buildAiDescriptionRequest
  }
})()

module.exports = AiDescriptionRequest
